import * as React from 'react'
import { Close as CloseIcon } from '@mui/icons-material'

import {
  Box,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  Slide,
} from '@design/pt-ui'

function SlideUpTransition(props: any) {
  return <Slide direction="up" {...props} />
}

const iconColors: Record<string, string> = {
  error: 'red',
  info: 'gray',
  warning: '#ffb37a',
}

export interface NotificationDialogCustomization {
  level: string
  title: string
  message: string
  buttonLabel: string
  onClose: () => any
}

function NotificationDialog(props: NotificationDialogCustomization) {
  const getIcon = () => {
    const color = iconColors[props.level]
    if (!color) {
      return null
    }
    const icon =
      props.level === 'error'
        ? 'error'
        : props.level === 'warning'
          ? 'warning'
          : 'info'
    return <Icon sx={{ fontSize: 44, color }}>{icon}</Icon>
  }

  return (
    <div>
      <Dialog
        disableRestoreFocus={true}
        open={true}
        onClose={props.onClose}
        TransitionComponent={SlideUpTransition}
        keepMounted={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {props.title}{' '}
          <IconButton
            aria-label="Close"
            sx={{ right: 1, color: 'grey.500' }}
            onClick={props.onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexFlow: 'row',
              justifyContent: 'center',
            }}>
            <DialogContentText id="alert-dialog-description">
              {getIcon()}
            </DialogContentText>
            <div style={{ marginLeft: 10 }}>{props.message}</div>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose} color="primary" autoFocus={true}>
            {props.buttonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default NotificationDialog
